
<app-content [content]="content">

</app-content>


